import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@zillow/constellation';
import { ColorPropType, SizePropType } from './prop-types.js';
import { MEDIA_TABLET, MEDIA_DESKTOP } from './constants.js';

var UpsellCard = function UpsellCard(_ref) {
  var _ref2;
  var button = _ref.button,
    children = _ref.children,
    className = _ref.className,
    color = _ref.color,
    size = _ref.size,
    id = _ref.id;
  return /*#__PURE__*/React.createElement(Box, {
    id: id,
    "aria-label": button,
    className: className,
    tabIndex: 0,
    sx: (_ref2 = {
      display: 'block',
      position: 'relative',
      fontFamily: '$fonts.sansSerif',
      // Heading
      '--heading': {
        blue: '$colors.blue400',
        darkBlue: '$colors.textWhite',
        gold: '$colors.yellow500',
        green: '$colors.green500',
        orange: '$colors.orange500',
        purple: '$colors.purple500',
        white: '$colors.textDark'
      }[color],
      // Text
      '--text': {
        blue: '$colors.trueBlack',
        darkBlue: '$colors.textWhite',
        gold: '$colors.trueBlack',
        green: '$colors.trueBlack',
        orange: '$colors.trueBlack',
        purple: '$colors.trueBlack',
        white: '$colors.textDark'
      }[color],
      '--text-legal': {
        blue: '$colors.textDark',
        darkBlue: '$colors.textLight',
        gold: '$colors.textDark',
        green: '$colors.textDark',
        orange: '$colors.textDark',
        purple: '$colors.textDark',
        white: '$colors.textLight'
      }[color],
      // Button
      '--button': {
        blue: '$colors.blue400',
        darkBlue: '$colors.blue400',
        gold: '$colors.yellow500',
        green: '$colors.green500',
        orange: '$colors.orange500',
        purple: '$colors.purple500',
        white: '$colors.blue400'
      }[color],
      '--button-hover': {
        blue: '$colors.blue500',
        darkBlue: '$colors.blue500',
        gold: '$colors.yellow600',
        green: '$colors.green600',
        orange: '$colors.orange600',
        purple: '$colors.purple600',
        white: '$colors.blue500'
      }[color],
      '--button-text': {
        blue: '$colors.textWhite',
        darkBlue: '$colors.textWhite',
        gold: '$colors.textWhite',
        green: '$colors.textWhite',
        orange: '$colors.textWhite',
        purple: '$colors.textWhite',
        white: '$colors.textWhite'
      }[color],
      // Background
      '--background': {
        blue: '$colors.blue200',
        darkBlue: '$colors.blue600',
        gold: '$colors.yellow100',
        green: '$colors.green100',
        orange: '$colors.orangeRed100',
        purple: '$colors.purple100',
        white: '$colors.backgroundWhite'
      }[color],
      backgroundColor: 'var(--background)',
      borderColor: color === 'white' ? '$colors.borderLight' : 'transparent',
      borderStyle: 'solid',
      borderWidth: '1px',
      borderRadius: '$radii.xl',
      padding: '$spacing.sm $spacing.md $spacing.md $spacing.md',
      '.Upsell__Button:active:not(:disabled), .Upsell__Button:focus:not(:disabled), .Upsell__Button:hover:not(:disabled)': {
        color: 'var(--button-text)',
        backgroundColor: 'var(--button-hover)',
        borderColor: 'var(--button-hover)'
      }
    }, _ref2[MEDIA_TABLET] = {
      padding: ['md', 'lg'].includes(size) ? '$spacing.xxl' : undefined,
      borderRadius: ['md', 'lg'].includes(size) ? '$radii.xxl' : undefined
    }, _ref2[MEDIA_DESKTOP] = {
      padding: size === 'xs' ? '$spacing.xl $spacing.xxl' : undefined
    }, _ref2)
  }, children);
};
UpsellCard.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string.isRequired,
  button: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  color: ColorPropType.isRequired,
  size: SizePropType.isRequired
} : {};
UpsellCard.defaultProps = {
  className: undefined
};
var UpsellCard$1 = UpsellCard;

export { UpsellCard$1 as default };
